<template>
  <v-col :cols="12" :sm="12" :md="12">
    <Alertas
      :notificacaoSocket="alertaSocket"
      :texto="alerta.texto"
      :tipo="alerta.tipo"
    ></Alertas>

    <DataTable
      v-show="showSkeletonTable == false"
      :tableTitle="'Nivel do Usuario'"
      :newRowmodalButtonText="'Novo nível'"
      :tableHeader="headers"
      :tableRows="nivel"
      :isEdit="true"
      :isFinish="false"
      :isDel="true"
      :isPrint="false"
      v-on:datatable-newrow="onDataTableInsertRow"
      v-on:datatable-updaterow="onDataTableUpdateRow"
      v-on:datatable-deleterow="onDataTableDeleteRow"
    ></DataTable>

    <SkeletonTable
      v-show="showSkeletonTable == true"
      :showSkeletonTable="showSkeletonTable"
    ></SkeletonTable>

    <ModalCustomSize
      :modalSize="modalCustomSizeData.modalSize"
      :isTheModalOpen="modalCustomSizeData.isOpen"
      :modalButtonText="modalCustomSizeData.buttonText"
      :modalFormTitle="modalCustomSizeData.formTitle"
      :modalType="modalCustomSizeData.modalType"
      :isLoadingRequestDisable="modalCustomSizeData.isLoadingRequestDisable"
      :isModalButtonVisible="modalCustomSizeData.isButtonsVisible"
      :isModalButtonDisabled="modalCustomSizeData.isButtonsDisabled"
      v-on:formmodal-close="fecharModel"
      v-on:formmodal-action="onFormModalAction"
    >
      <v-col cols="12">
        <AlertasModal
          :tipo="alertaModal.tipo"
          :texto="alertaModal.texto"
        ></AlertasModal>
      </v-col>
      <v-form v-model="estaValido">
        <v-row>
          <v-col cols="6">
            <v-text-field
              v-model="modalCustomSizeData.actualEdit.nomeNivel"
              :rules="nomeRules"
              name="nomeNivel"
              label="Nome do nível"
              autocomplete="off"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="modalCustomSizeData.actualEdit.descricaoNivel"
              :rules="descricaoRules"
              name="descricaoNivel"
              label="Descrição do nível"
              autocomplete="off"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-autocomplete
              :items="permissoes"
              v-model="permissaoSelecionada"
              autocomplete="off"
              append-outer-icon="mdi-plus-thick"
              @click:append-outer="adicionarPermissao()"
            >
            </v-autocomplete>
          </v-col>
          <v-col>
            <v-data-table
              :headers="modalCustomSizeData.actualEdit.permissaoHeaders"
              :items="modalCustomSizeData.actualEdit.permissaoVinculada"
              :search="search"
            >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Permissões Vinculadas</v-toolbar-title>
                </v-toolbar>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon small @click="removePermissaoDaLista(item)">
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-form>
    </ModalCustomSize>
  </v-col>
</template>

<script>
import axios from "../plugins/axios";
import DataTable from "@/components/DataTable2.vue";
import ModalCustomSize from "../components/ModalCustomSize";
import store from "@/store/index";
import SkeletonTable from "../components/SkeletonTable";
import Alertas from "../components/Alertas.vue";
import AlertasModal from "../components/AlertasModal.vue";

export default {
  components: {
    DataTable,
    ModalCustomSize,
    SkeletonTable,
    Alertas,
    AlertasModal,
  },

  data: () => ({
    rules: {
      requerido: (value) => !!value || "Requer o campo!",
      email: (v) =>
        !v ||
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "Formato de E-mail inválido.",
    },

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    newNotify: {
      isNewNotify: false,
      text: "",
    },

    alerta: {
      texto: "",
      tipo: "",
    },

    alertaSocket: {
      texto: "",
      tipo: "",
    },

    alertaModal: {
      texto: "",
      tipo: "",
    },

    showSkeletonTable: true,
    permissaoSelecionada: null,
    search: null,
    estaValido: false,

    nomeRules: [
        v => !!v || 'Nome é obrigatório',
        v => (v && v.length <= 255) || 'O nome informado é muito grande.',
    ],
    descricaoRules: [
        v => !!v || 'Descrição é obrigatória',
        v => (v && v.length <= 255) || 'A descrição informada é muito grande.',
    ],

    // Cabeçalho da DataTable
    headers: [
      {
        text: "ID",
        value: "numeroNivel",
      },
      {
        text: "Nome",
        value: "nomeNivel",
      },
      {
        text: "Descrição",
        value: "descricaoNivel",
      },
      { text: "Atualizar/Excluir", value: "actions", sortable: false },
    ],

    modalCustomSizeData: {
      modalSize: "1100",
      isOpen: false,
      buttonText: "",
      formTitle: "",
      isEdit: false,
      isButtonsVisible: true,
      isButtonsDisabled: false,
      isLoadingRequestDisable: false,
      actualEdit: {
        numeroNivel: null,
        nomeNivel: null,
        descricaoNivel: null,
        descricaoTela: "nivel",
        permissaoHeaders: [
          {
            text: "ID",
            value: "permissao.numeroPermissao",
          },
          {
            text: "Nome Permissao",
            value: "permissao.nomePermissao",
          },
          {
            text: "Descrição Permissao",
            value: "permissao.descricaoPermissao",
          },
          { text: "Visualizar", value: "actions", sortable: false },
        ],
        permissaoVinculada: [],
      },
    },

    //Array populado pela função initialize
    nivel: [],
    permissoes: [],
  }),

  created() {
    this.initialize();
  },
  
  watch: {
    estaValido() {
      this.modalCustomSizeData.isButtonsDisabled = !this.estaValido
    }
  },

  methods: {
    /****************************************************************
     *                 FUNÇÕES DE EVENTO
     **************************************************************** */

    onDataTableInsertRow() {
      this.alertaModal.texto = null
      this.alertaModal.tipo = null;

      this.modalCustomSizeData.isOpen = true;
      this.modalCustomSizeData.isEdit = false;
      this.modalCustomSizeData.isButtonsDisabled = !this.estaValido
      this.modalCustomSizeData.buttonText = "Registrar";
      this.modalCustomSizeData.formTitle = "Novo Nível";

      this.modalCustomSizeData.actualEdit.numeroNivel = null;
      this.modalCustomSizeData.actualEdit.nomeNivel = null;
      this.modalCustomSizeData.actualEdit.descricaoNivel = null;

      this.modalCustomSizeData.actualEdit.permissaoVinculada = []
    },

    async onDataTableUpdateRow(item) {
      this.alertaModal.texto = null
      this.alertaModal.tipo = null;

      this.modalCustomSizeData.isOpen = true;
      this.modalCustomSizeData.isEdit = true;
      this.modalCustomSizeData.isButtonsDisabled = !this.estaValido
      this.modalCustomSizeData.buttonText = "Salvar";
      this.modalCustomSizeData.formTitle = "Atualizar Nível do Usuario";

      this.modalCustomSizeData.actualEdit.numeroNivel = item.numeroNivel;
      this.modalCustomSizeData.actualEdit.nomeNivel = item.nomeNivel;
      this.modalCustomSizeData.actualEdit.descricaoNivel = item.descricaoNivel;

      let listaDePermissoes = await axios.post("nivelPorPermissao",
        { numeroNivel: item.numeroNivel },
        this.config
      );

      this.modalCustomSizeData.actualEdit.permissaoVinculada = listaDePermissoes.data;
    },

    async onDataTableDeleteRow(item) {
      try {
        await this.delete(item);
      } catch (error) {
        console.log(error);
      } finally {
        await this._listarNivel();
      }
    },

    fecharModel(){
      this.modalCustomSizeData.isOpen = false
        this.alertaModal.texto = null
        this.alertaModal.tipo = null
    },

    async onFormModalAction() {
      try {
        this.modalCustomSizeData.isButtonsDisabled = true;
        if (this.modalCustomSizeData.isEdit) {
          await this.update(this.modalCustomSizeData.actualEdit);
        } else {
          await this.insert(this.modalCustomSizeData.actualEdit);
        }
      } catch (error) {
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      } finally {
        await this._listarNivel();
        this.modalCustomSizeData.isButtonsDisabled = false;
        this.modalCustomSizeData.isOpen = false;
      }
    },

    /****************************************************************
     *                 FUNÇÕES DO COMPONENTE
     **************************************************************** */

    removePermissaoDaLista(item) {
      this.modalCustomSizeData.actualEdit.permissaoVinculada = this.modalCustomSizeData.actualEdit.permissaoVinculada.filter(
        (permissao) =>
          permissao.permissao.numeroPermissao != item.permissao.numeroPermissao
      );
    },

    adicionarPermissao() {
      const permissoesFiltradas = this.modalCustomSizeData.actualEdit.permissaoVinculada.filter((permissao) =>
        permissao.permissao.numeroPermissao == this.permissaoSelecionada.permissao.numeroPermissao
      );

      if(permissoesFiltradas.length <= 0) {
        this.modalCustomSizeData.actualEdit.permissaoVinculada.push(
          this.permissaoSelecionada
        );
      } else {
        this.alertaModal.texto = 'A permissão já foi adicionada na lista!'
        this.alertaModal.tipo = 'erro'
      }

      this.permissaoSelecionada = null
    },

    fecharNotificacao() {
      this.newNotify.isNewNotify = false;
    },

    async _listarNivel() {
      try {
        const response = await axios.get("nivel", this.config);
        this.showSkeletonTable = false;
        this.nivel = response.data;
      } catch (error) {
        console.log(error.response);
      }
    },

    async _listarPermissao() {
      try {
        const response = await axios.get("permissao", this.config);
        this.permissoes = response.data.map(function(permissaoSelecionada) {
          return {
            text: permissaoSelecionada.nomePermissao,
            value: {permissao: permissaoSelecionada}
          };
        });
      } catch (error) {
        console.log(error.response);
      }
    },

    async initialize() {
      try {
        await this._listarNivel();
        await this._listarPermissao();
      } catch (error) {
        console.log(error.response);
      }
    },

    async insert(reciveItem) {
      try {
        this.alertaModal.tipo = null;
        this.modalCustomSizeData.isLoadingRequestDisable = true;

        await axios.post("nivel", reciveItem, this.config);
        // this.$socket.emit("insert", reciveItem);
        this.$socket.emit("insertLog");

        this.alerta.texto = "Nivel adicionado com sucesso!";
        this.alerta.tipo = "sucesso";

        this.modalCustomSizeData.isLoadingRequestDisable = false;
        return true;
      } catch (error) {
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      } finally {
        this.modalCustomSizeData.isLoadingRequestDisable = false;
        this.permissaoSelecionada = null;
      }
    },

    async update(reciveItem) {
      try {
        this.alertaModal.tipo = null;
        this.modalCustomSizeData.isLoadingRequestDisable = true;

        await axios.put("nivel", reciveItem, this.config);
        // this.$socket.emit("update", reciveItem);
        this.$socket.emit("insertLog");

        this.alerta.texto = "Nivel atualizado com sucesso!";
        this.alerta.tipo = "sucesso";

        this.modalCustomSizeData.isLoadingRequestDisable = false;
        return true;
      } catch (error) {
        this.mensagemErro = error.response.data.message;
        this.erro = true;
      } finally {
        this.modalCustomSizeData.isLoadingRequestDisable = false;
        this.permissaoSelecionada = null;
      }
    },

    async delete(reciveItem) {
      try {
        if (confirm("Você realmente deseja excluir este Nivel?")) {
          this.modalCustomSizeData.isLoadingRequestDisable = true;
          reciveItem.descricaoTela = "nivel";

          await axios.delete("nivel", {
            data: reciveItem,
            headers: this.config.headers,
          });
          // this.$socket.emit("delete", reciveItem);
          this.$socket.emit("insertLog");

          this.alerta.texto = "Nivel removido";
          this.alerta.tipo = "sucesso";

          this.modalCustomSizeData.isLoadingRequestDisable = false;
          return true;
        }
      } catch (error) {
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      } finally {
        this.modalCustomSizeData.isLoadingRequestDisable = false;
      }
    },
  },
};
</script>
